import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-communication-incoming-box-icon',
  templateUrl: './communication-incoming-box.component.html'
})
export class CommunicationIncomingBoxComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
